/**=========================================================
 * Module: sidebar-menu.js
 * Provides a simple way to implement bootstrap collapse plugin using a target
 * next to the current element (sibling)
 * Targeted elements must have [data-toggle="collapse-next"]
 =========================================================*/
App.controller('SidebarController', ['$rootScope', '$scope', '$state', '$location', '$http', '$timeout', 'APP_MEDIAQUERY', '$filter', '$timeout',
  function($rootScope, $scope, $state, $location, $http, $timeout, mq, $filter, $timeout){

    var currentState = $rootScope.$state.current.name;
    var $win = $(window);
    var $html = $('html');
    var $body = $('body');

    var rootScopeEventListeners = [];

    rootScopeEventListeners.push($rootScope.$on('$userLoggedOn', function(){
        $scope.loadSidebarMenu(0);
    }));
    // Adjustment on route changes
    rootScopeEventListeners.push($rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      currentState = toState.name;
      // Hide sidebar automatically on mobile
      $('body.aside-toggled').removeClass('aside-toggled');

      $rootScope.$broadcast('closeSidebarMenu');
    }));

    $scope.resizeAside = function(){
      $('aside').height($win.height() - $('header.topnavbar-wrapper').height());
    }

    // Normalize state on resize to avoid multiple checks
    $win.on('resize', function() {
      if( isMobile() )
        $body.removeClass('aside-collapsed');
      else{
        $body.removeClass('aside-toggled');
        $scope.resizeAside()
      }
    });

    // Check item and children active state
    var isActive = function(item) {

      if(!item) return;

      if( !item.sref || item.sref == '#') {
        var foundActive = false;
        angular.forEach(item.submenu, function(value, key) {
          if(isActive(value)) foundActive = true;
        });
        return foundActive;
      }
      else{
        let s = $state.getCurrentPath();
        s = s[s.length-1];
        let sname = s.state.name
        let iname = item.sref.split('(')[0]
        let hasP = item.sref.indexOf('(')>=0
        let sparams = s.paramValues || {}
        let iparams = hasP ? $rootScope.$eval(item.sref.split('(')[1].split(')')[0]) : {}
        
        return $state.is(item.sref) || $state.includes(item.sref) || (sname==iname && sparams.action==iparams.action && sparams.filter==iparams.filter && sparams.type==iparams.type);
      }

    };

    // Load menu from json file
    // -----------------------------------

    $scope.getMenuItemPropClasses = function(item) {
      let si = ''
      if(item.submenuitem){
        if(item.submenuitem.show) si = ' scale-in-ver-top'
        else si = ' scale-out-ver-top'
      }
      return (item.heading ? 'nav-heading' : '') +
             (isActive(item) ? ' active' : '') + si;
    };

    $scope.toggleSubmenu = function(name){
      if(!name) return;
      let open = null
      $rootScope.menuItems.forEach(function(item){
        if(item.submenu && item.submenu.name==name){
          item.submenu.open = !item.submenu.open
          open = item.submenu.open
        }
        if(item.submenuitem && item.submenuitem.of==name){
          item.submenuitem.show = open
        }
      })
    }

    $scope.loadSidebarMenu = function(times) {
      if($rootScope.user && $rootScope.user.groupType){
        var menuJson = 'app/json/menu_'+$rootScope.user.groupType.toLowerCase()+'.json',
            menuURL  = menuJson + '?v=' + (new Date().getTime()); // jumps cache
        $http.get(menuURL)
          .then(function(data) {
            var items = data.data
            var submenus = {}
            let foundTranslation = times > 20 || $filter('translate')('Id') == $rootScope.user.language
            for(var i=0; i<items.length; i++){
              if(items[i].translate){
                items[i].text = $filter('translate')(items[i].translate);
                //if(items[i].text!=items[i].translate) foundTranslation = true
              }
              if(items[i].value){
                items[i].text += (items[i].value.prefix ? items[i].value.prefix : '') + $filter('display')($rootScope.$eval(items[i].value.source) || items[i].value.def, items[i].value.display)
              }
              if(items[i].submenu){
                submenus[items[i].submenu.name] = items[i].submenu
              }
              if(items[i].submenuitem){
                items[i].submenuitem.show = !!submenus[items[i].submenuitem.of].open
              }
            }
            if(!foundTranslation){
              $timeout(function(){$scope.loadSidebarMenu(times+1);},1000)
              return
            }
            $rootScope.menuItems = items;
          })
          .catch(function(data, status, headers, config) {
            
          });
      } else {
        $rootScope.menuItems = [];
      }
     };

     //$scope.loadSidebarMenu();

    // Handle sidebar collapse items
    // -----------------------------------
    var collapseList = [];

    $scope.addCollapse = function($index, item) {
      collapseList[$index] = !isActive(item);
    };

    $scope.isCollapse = function($index) {
      return (collapseList[$index]);
    };

    $scope.toggleCollapse = function($index, isParentItem) {

      // collapsed sidebar doesn't toggle drodopwn
      if( isSidebarCollapsed() && !isMobile() ) return true;
      // make sure the item index exists
      if( angular.isDefined( collapseList[$index] ) ) {
        collapseList[$index] = !collapseList[$index];
        closeAllBut($index);
      }
      else if ( isParentItem ) {
        closeAllBut(-1);
      }


      return true;

      function closeAllBut(index) {
        index += '';
        for(var i in collapseList) {
          if(index < 0 || index.indexOf(i) < 0)
            collapseList[i] = true;
        }
        // angular.forEach(collapseList, function(v, i) {
        // });

      }
    };

    // Helper checks
    // -----------------------------------

    function isMobile() {
      return $win.width() < mq.tablet;
    }
    function isTouch() {
      return $html.hasClass('touch');
    }
    function isSidebarCollapsed() {
      return $body.hasClass('aside-collapsed');
    }
    function isSidebarToggled() {
      return $body.hasClass('aside-toggled');
    }

    for(var i=0; i<rootScopeEventListeners.length; i++){
      $scope.$on('$destroy', rootScopeEventListeners[i]);
    }
}]);
